
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { LabelId_$reflection, CustomIntervalDefinition_$reflection, ReminderInterval_$reflection, InspectionTemplateId_$reflection } from "./Shared.js";
import { record_type, class_type, bool_type, list_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class InspectionTemplate extends Record {
    constructor(Id, Name, Description, Interval, CustomInterval, NotificationInterval, SuccessfulResults, FailedResults, CategoryIds, IsUsed, CreatedAt, UpdatedAt) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.Interval = Interval;
        this.CustomInterval = CustomInterval;
        this.NotificationInterval = NotificationInterval;
        this.SuccessfulResults = SuccessfulResults;
        this.FailedResults = FailedResults;
        this.CategoryIds = CategoryIds;
        this.IsUsed = IsUsed;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function InspectionTemplate_$reflection() {
    return record_type("Shared.InspectionTemplate.InspectionTemplate", [], InspectionTemplate, () => [["Id", InspectionTemplateId_$reflection()], ["Name", string_type], ["Description", string_type], ["Interval", ReminderInterval_$reflection()], ["CustomInterval", option_type(CustomIntervalDefinition_$reflection())], ["NotificationInterval", option_type(CustomIntervalDefinition_$reflection())], ["SuccessfulResults", list_type(string_type)], ["FailedResults", list_type(string_type)], ["CategoryIds", list_type(LabelId_$reflection())], ["IsUsed", bool_type], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class DTO_WriteInspectionTemplateDto extends Record {
    constructor(Name, Description, Interval, CustomInterval, NotificationInterval, SuccessfulResults, FailedResults, CategoryIds) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.Interval = Interval;
        this.CustomInterval = CustomInterval;
        this.NotificationInterval = NotificationInterval;
        this.SuccessfulResults = SuccessfulResults;
        this.FailedResults = FailedResults;
        this.CategoryIds = CategoryIds;
    }
}

export function DTO_WriteInspectionTemplateDto_$reflection() {
    return record_type("Shared.InspectionTemplate.DTO.WriteInspectionTemplateDto", [], DTO_WriteInspectionTemplateDto, () => [["Name", string_type], ["Description", string_type], ["Interval", ReminderInterval_$reflection()], ["CustomInterval", option_type(CustomIntervalDefinition_$reflection())], ["NotificationInterval", option_type(CustomIntervalDefinition_$reflection())], ["SuccessfulResults", list_type(string_type)], ["FailedResults", list_type(string_type)], ["CategoryIds", list_type(LabelId_$reflection())]]);
}

export class DTO_InspectionTemplateDetailDto extends Record {
    constructor(Id, Name, Description, Interval, CustomInterval, NotificationInterval, SuccessfulResults, FailedResults, CategoryIds, IsUsed) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.Interval = Interval;
        this.CustomInterval = CustomInterval;
        this.NotificationInterval = NotificationInterval;
        this.SuccessfulResults = SuccessfulResults;
        this.FailedResults = FailedResults;
        this.CategoryIds = CategoryIds;
        this.IsUsed = IsUsed;
    }
}

export function DTO_InspectionTemplateDetailDto_$reflection() {
    return record_type("Shared.InspectionTemplate.DTO.InspectionTemplateDetailDto", [], DTO_InspectionTemplateDetailDto, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Description", string_type], ["Interval", ReminderInterval_$reflection()], ["CustomInterval", option_type(CustomIntervalDefinition_$reflection())], ["NotificationInterval", option_type(CustomIntervalDefinition_$reflection())], ["SuccessfulResults", list_type(string_type)], ["FailedResults", list_type(string_type)], ["CategoryIds", list_type(class_type("System.Guid"))], ["IsUsed", bool_type]]);
}

